/*
** Floating Labels
*/

/* eslint-disable linebreak-style */
/* eslint-disable no-redeclare */
/* eslint-disable linebreak-style */
/* eslint-disable vars-on-top */
/* eslint-disable block-scoped-var */
/* eslint-disable linebreak-style */
/* eslint-disable no-var */
/* eslint-disable linebreak-style */

// Selectors
var inputs = document.querySelectorAll('.add-float-labels input[type="text"], .add-float-labels input[type="password"], .add-float-labels input[type="email"], .add-float-labels input[type="search"], .add-float-labels input[type="url"], .add-float-labels input[type="tel"], .add-float-labels input[type="number"], .add-float-labels textarea');
var selects = document.querySelectorAll('.add-float-labels select');
var floatClass = 'label-float';

var formContainers = document.querySelectorAll('.add-float-labels');
var formFloatClass = 'active-float-labels';

// Solve for no JS
for (var i = 0; i < formContainers.length; i++) {
    formContainers[i].classList.add(formFloatClass);
}

// Function
var floatLabel = function floatLabel(e) {
    var eventType = e.type;
    var input = e.target;
    var label = input.nextElementSibling;

    if (input != null && label != null) {
        if (eventType === 'keyup' && input.value.length !== 0) {
            input.classList.add(floatClass);
            label.classList.add(floatClass);
        }

        if (eventType === 'blur' && input.value.length === 0) {
            input.classList.remove(floatClass);
            label.classList.remove(floatClass);
        }
    }
};

var floatSelectClick = function floatSelectClick(e) {
    var eventType = e.type;
    var select = e.target.parentNode;
    var label = select.nextElementSibling;

    if (select != null && label != null) {
        if (eventType === 'click') {
            select.classList.add(floatClass);
            label.classList.add(floatClass);
        }
    }
};

var floatSelectKeyboard = function floatSelectKeyboard(e) {
    var eventType = e.type;
    var select = e.target;
    var label = select.nextElementSibling;

    if (select != null && label != null) {
        if (eventType === 'change') {
            select.classList.add(floatClass);
            label.classList.add(floatClass);
        }
    }
};

// Event Handlers
for (var i = 0; i < inputs.length; i++) {
    var label = inputs[i].nextElementSibling;
    if (inputs[i].value.length !== 0) {
        inputs[i].classList.add(floatClass);
        label.classList.add(floatClass);
    }
    inputs[i].addEventListener('keyup', floatLabel);
    inputs[i].addEventListener('blur', floatLabel);
}

for (var i = 0; i < selects.length; i++) {
    var label = selects[i].nextElementSibling;
    selects[i].classList.add(floatClass);
    label.classList.add(floatClass);
    selects[i].addEventListener('click', floatSelectClick);
    selects[i].addEventListener('change', floatSelectKeyboard);
}



// WEBPACK FOOTER //
// ./scripts/partials/component-label.js